import { render, staticRenderFns } from "./informationSet.vue?vue&type=template&id=1985ed83&scoped=true"
import script from "./informationSet.vue?vue&type=script&lang=js"
export * from "./informationSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1985ed83",
  null
  
)

export default component.exports